import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, EmptyState } from '../components/ui.js';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="center-screen">
      <EmptyState
        icon="🧭"
        title={t('errors.notFound')}
        action={
          <Link to="/">
            <Button variant="primary">{t('nav.dashboard')}</Button>
          </Link>
        }
      />
    </div>
  );
}
